import React from 'react'
import NavBar from '../Components/NavBar'
import SimpleFooter from '../Components/SimpleFooter'

function Downloads() {
  return (
    <div>

      <div className='headerSectionHome'>
          <div className='opacity2'></div>
            <NavBar/>
            <div className='headerHomeText'>
                <h6>Available Downloads</h6>
                <h4>Downloads</h4>
            </div>
        </div>

        <section className='availableDownloads table-responsive'>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">File Name</th>
              <th scope="col">Software Type</th>
              <th scope="col">Operating System</th>
              <th scope="col">Version</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ubunifu College Android App</td>
              <td>Mobile Application</td>
              <td>Android</td>
              <td>Latest</td>
              <td>
                <a
                  href="https://play.google.com/store/apps/details?id=com.ubunifu.college"
                  className="btn btn-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  Open in Play Store
                </a>
              </td>
            </tr>
 
          </tbody>
        </table>

        </section>




        {/* <section className='aboutSec'>

          <div className='abSec1'>
            <h6>CENTRE FOR AI RESEARCH & DEVELOPMENT</h6>
            <h3>Live Interactive Virtual classes.</h3>
            <p>Get a classroom experience from anywhere you are, interact with fellow students, build and launch amazing products!</p>
            <a href='https://ubunifucollege.com/apply' className='signUpbtn'>Sign Up</a>
          </div>

          <div className='abSec2'>
            <img src={theMain2} alt="" className='boy4'/>
            <div className='lineCont'>           
              <div className='theLine'/> <p> Project Based Learning</p>
            </div>        
          </div>

          <div className='abSec3'>
            <img src={theMaggie} alt="" className='boy4'/>
            <div className='lineCont'>
              <div className='theLine'/> <p>Learn from accomplished Devs</p>
            </div>      
          </div>

        </section> */}
      <SimpleFooter/>
    </div>
  )
}

export default Downloads
